import React, { Component } from 'react';
// Removed MusicEngine silent bridge to avoid unintended API calls during Firebase login
import { withRouter } from 'react-router-dom';
import logo from 'assets/logo.png';
import googleLogo from 'assets/google.png';
import guestLogo from 'assets/dummy-profile.png';
import { auth, googleProvider, signInWithPopup } from 'utils/firebaseConfig';
import { ensureMusicEngineTokenForFirebaseUser, getUnifiedCurrentUser, fetchMusicEngineUserAfterVerify } from 'api/api';
import Style from 'pages/signIn/signInStyles.module.css';
import PageSpinner from 'components/Spinner/PageSpinner';

class SignInPage extends Component {

    constructor(props) {
        super(props);
        this.googleBtn = React.createRef();
        this.state = {
            errorMsg: ''
        };

        this.onKeyDown = this.onKeyDown.bind(this);
        this.clearError = this.clearError.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
        this.handleSignIn = this.handleSignIn.bind(this);
        // no other bindings needed
    }

    async componentDidMount() {
        document.addEventListener('keydown', this.onKeyDown);
        if (!this.state.errorMsg.length && this.googleBtn.current) {
            this.googleBtn.current.focus();
        }
        // If already logged in (Firebase), ensure ME token then base routing on ME /auth/user
        this.getUser();
        this.unblock = this.props.history.block((location, action) => {
            return action === 'POP' ? false : undefined;
        });
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyDown);
        if (this.unblock) {
            this.unblock();
        }
    }

    getUser = async () => {
        try {
            if (auth.currentUser) {
                try { await ensureMusicEngineTokenForFirebaseUser(auth.currentUser); } catch {}
                try {
                    const { user } = await getUnifiedCurrentUser();
                    const hasBasics = !!((user?.name || user?.displayName) && user?.gender && user?.country);
                    const hasDob = !!user?.birth;
                    const hasAll = hasBasics && hasDob;
                    this.props.history.push(hasAll ? '/podcast' : '/updateprofile');
                } catch (e) {
                    this.props.history.push('/updateprofile');
                }
            }
        } catch (error) {}
    };

    onKeyDown(e) {
        // Ignore when typing in form fields
        const target = e && e.target;
        const tag = target && target.tagName ? target.tagName.toLowerCase() : '';
        const isFormField = tag === 'input' || tag === 'textarea' || tag === 'select' || (target && target.isContentEditable);
        if (isFormField) {
            return;
        }
        return;
        const { activeTab, errorMsg } = this.state;
        if (e.key === 'ArrowUp' && activeTab > 0) {
            this.setState({ activeTab: activeTab - 1 });
        } else if (e.key === 'ArrowDown' && activeTab < 2) {
            this.setState({ activeTab: activeTab + 1 });
        } else if (e.key === 'Enter' && errorMsg.length) {
            this.clearError();
        } else if (e.key === 'Backspace' || e.key === 'ArrowRight') {
            this.props.history.goBack();
        }
    }

    async handleSignIn() {
        const { setShowLoader } = this.props;
        try {
            setShowLoader(true);
            googleProvider.addScope('profile');
            if (process.env.REACT_APP_FIREBASE_REDIRECT_URI) {
                googleProvider.setCustomParameters({ redirect_uri: process.env.REACT_APP_FIREBASE_REDIRECT_URI });
            }
            await signInWithPopup(auth, googleProvider);
            // After Google sign-in: ensure ME token via verify, then decide based on /auth/user
            let routeToPodcast = false;
            try {
                const { token, meUser } = await fetchMusicEngineUserAfterVerify(auth.currentUser);
                if (meUser) {
                    const u = (meUser.user || meUser.data || meUser);
                    const nameVal = u.name || u.username || u.displayName;
                    const genderVal = u.gender || u.profile?.gender || u.profile?.sex;
                    const countryVal = u.country || u.country_code || u.profile?.country || u.profile?.country_code;
                    const dobVal = u.birth || u.birth_date || u.dob || u.date_of_birth || u.profile?.dob || u.profile?.date_of_birth;
                    routeToPodcast = !!(nameVal && genderVal && countryVal && dobVal);
                }
            } catch {}
            setShowLoader(false);
            if (this.unblock) this.unblock();
            if (!routeToPodcast) {
                this.props.history.push('/updateprofile', { isProfileCompletion: true });
            } else {
                this.props.history.push('/podcast');
            }
        } catch (err) {
            setShowLoader(false);
            this.setState({ errorMsg: err.message || 'Something went wrong' });
        }
    }

    handleContinue() {
        if (this.unblock) {
            this.unblock();
        }
        this.props.history.push(`/discover`);
    }

    // Legacy ME login/signup removed from UI on KaiOS landing per requirement

    onChangeField(section, field, value) {
        this.setState((prev) => ({
            ...prev,
            [section]: { ...prev[section], [field]: value },
        }));
    }

    clearError() {
        this.setState({ errorMsg: '' });
    }

    render() {
        const { showLoader } = this.props;
        const { errorMsg } = this.state;

        if (showLoader) {
            return <PageSpinner />;
        }

        return (
            <div className={Style.SignInLayout}>
                {errorMsg && (
                    <div className={Style.backdrop} onClick={this.clearError}>
                        <div className={Style.errorWrapper}>
                            <span className={Style.closeIcon} onClick={this.clearError} style={{ border: '1px solid #451e53' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                    <path fill="red" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                            </span>
                            <div className={Style.title}>Error</div>
                            <div className={Style.erMsg}>{errorMsg}</div>
                        </div>
                    </div>
                )}
                <img src={logo} style={{ height: '150px' }} alt="Logo" />
                {/* Only two options on landing: Google or Guest */}

                {/* Keep Google as optional alternative */}
                <div className={Style.btnWrapper}>
                    <button className={Style.button} onClick={this.handleSignIn} ref={this.googleBtn}>
                        <span className={Style.SignInButtonsContainer}>
                            <img src={googleLogo} style={{ height: '24px', marginRight: '8px' }} alt="Sign in with Google" />
                            <span className={Style.btnText}>Sign in with Google</span>
                        </span>
                    </button>
                </div>
                <div className={Style.btnWrapper}>
                    <button className={Style.button} onClick={this.handleContinue}>
                        <span className={Style.SignInButtonsContainer}>
                            <img src={guestLogo} style={{ height: '24px', marginRight: '8px' }} alt="Continue as Guest" />
                            <span className={Style.btnText}>Continue as Guest</span>
                        </span>
                    </button>
                </div>
            </div>
        );
    }

}

export default withRouter(SignInPage);